/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.27.0
 */

/**
 * Adds a comma to a word by index if it's not the last word in the array
 * @param word - The word to add a comma to
 * @param index - The index of the word in the array
 * @param arrayLength - The length of the array of words
 * @param lastWordEnding - The ending of the last word in the array
 * @returns The word with a comma or lastWordEnding
 */
export const addCommaToWordByIndex = (
    word: string,
    index?: number,
    arrayLength?: number,
    lastWordEnding?: '' | '.',
): string => {
    if (typeof index === 'undefined' || typeof arrayLength === 'undefined') {
        return word;
    }

    if (index === arrayLength - 1) {
        return word + (lastWordEnding ?? '');
    } else {
        return word + ',';
    }
};
